import localFiles from '@/assets/sfx';

import { randomElement, last } from './lib';

const createAudioWrapper = sound => new Audio(sound);

class Sounds {
  constructor(sfx) {
    this.sfx = sfx;
  }

  flipNormal(item) {
    if (item.vocal) {
      return createAudioWrapper(this.sfx[item.vocal][item.value]);
    }
    return createAudioWrapper(randomElement(this.sfx.flipNormal));
  }

  flipMatch() {
    return createAudioWrapper(randomElement(this.sfx.flipMatching));
  }

  levelUp(level = 1) {
    if (level >= this.sfx.levelUp.length) {
      return createAudioWrapper(last(this.sfx.levelUp));
    }
    return createAudioWrapper(this.sfx.levelUp[level]);
  }
}

const createSounds = () => new Sounds(localFiles);

export default createSounds();
